import React from 'react'

const internalContext = React.createContext({
})

internalContext.displayName = "SecurSpaceGlobalModalContext"

export const GlobalModalContext = internalContext
